import { ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../assets/avatar.png';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {

  useEffect(() => {
    // Lógica para o toggle da sidebar (provavelmente do seu app.js)
    const sidebar = document.querySelector('.js-sidebar');
    const sidebarToggle = document.querySelector('.js-sidebar-toggle');

    if (sidebar && sidebarToggle) {
      const toggleSidebar = () => {
        sidebar.classList.toggle('collapsed');
      };

      // Fecha o menu ao clicar em algum link (apenas no mobile)
      const closeSidebarOnMobile = (e: Event) => {
        const target = e.target as HTMLElement;
        if (target.closest('.sidebar-link') && window.innerWidth < 992) {
          sidebar.classList.remove('collapsed');
        }
      };

      sidebarToggle.addEventListener('click', toggleSidebar);
      sidebar.addEventListener('click', closeSidebarOnMobile);

      // Função de limpeza para remover o listener ao desmontar o componente
      return () => {
        sidebarToggle.removeEventListener('click', toggleSidebar);
        sidebar.removeEventListener('click', closeSidebarOnMobile);
      };
    }
  }, []); // O array vazio [] garante que o efeito rode apenas uma vez, após a montagem inicial

  return (
    <div className="wrapper">
	<nav id="sidebar" className="sidebar js-sidebar">
		<div className="sidebar-content js-simplebar">
			<Link className="sidebar-brand" to="/">
				<span className="align-middle">Imob</span>
			</Link>

			<ul className="sidebar-nav">

				<li className="sidebar-item active">
					<Link className="sidebar-link" to="/home">
						<i className="align-middle bi bi-sliders"></i> <span className="align-middle">Home</span>
					</Link>
				</li>

				<li className="sidebar-item">
					<Link className="sidebar-link" to="/administradores">
						<i className="align-middle bi bi-person-badge"></i> <span className="align-middle">Administradores</span>
					</Link>
				</li>

				<li className="sidebar-item">
					<Link className="sidebar-link" to="/corretores">
						<i className="align-middle bi bi-person-badge"></i> <span className="align-middle">Corretores</span>
					</Link>
				</li>

				<li className="sidebar-item">
					<Link className="sidebar-link" to="/clientes">
						<i className="align-middle bi bi-people"></i> <span className="align-middle">Clientes</span>
					</Link>
				</li>

        		<li className="sidebar-item">
					<Link className="sidebar-link" to="/imoveis">
						<i className="align-middle bi bi-people"></i> <span className="align-middle">Imóveis</span>
					</Link>
				</li>

        		<li className="sidebar-item">
					<Link className="sidebar-link" to="/comodidades">
						<i className="align-middle bi bi-gem"></i> <span className="align-middle">Comodidades</span>
					</Link>
				</li>

        		<li className="sidebar-item">
					<Link className="sidebar-link" to="/agendas">
						<i className="align-middle bi bi-calendar-event"></i> <span className="align-middle">Agenda</span>
					</Link>
				</li>
			</ul>				
		</div>
	</nav>

	<div className="main">
		<nav className="navbar navbar-expand navbar-light navbar-bg">
			<a className="sidebar-toggle js-sidebar-toggle">
				<i className="hamburger align-self-center"></i>
			</a>

			<div className="navbar-collapse collapse">
				<ul className="navbar-nav navbar-align">
					{/* <li className="nav-item dropdown">
						<a className="nav-icon dropdown-toggle" href="#" id="alertsDropdown" data-bs-toggle="dropdown">
							<div className="position-relative">
								<i className="bi bi-bell"></i>
								<span className="indicator">4</span>
							</div>
						</a>
						<div className="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0" aria-labelledby="alertsDropdown">
							<div className="dropdown-menu-header">
								4 New Notifications
							</div>
							<div className="list-group">
								<a href="#" className="list-group-item">
									<div className="row g-0 align-items-center">
										<div className="col-2">
											<i className="text-danger" data-feather="alert-circle"></i>
										</div>
										<div className="col-10">
											<div className="text-dark">Update completed</div>
											<div className="text-muted small mt-1">Restart server 12 to complete the update.</div>
											<div className="text-muted small mt-1">30m ago</div>
										</div>
									</div>
								</a>
								<a href="#" className="list-group-item">
									<div className="row g-0 align-items-center">
										<div className="col-2">
											<i className="text-warning" data-feather="bell"></i>
										</div>
										<div className="col-10">
											<div className="text-dark">Lorem ipsum</div>
											<div className="text-muted small mt-1">Aliquam ex eros, imperdiet vulputate hendrerit et.</div>
											<div className="text-muted small mt-1">2h ago</div>
										</div>
									</div>
								</a>									
							</div>
							<div className="dropdown-menu-footer">
								<a href="#" className="text-muted">Show all notifications</a>
							</div>
						</div>
					</li>					 */}
					<li className="nav-item dropdown">
						<a className="nav-link dropdown-toggle d-inline-block" href="#" data-bs-toggle="dropdown">
							<img src={avatar} className="avatar img-fluid rounded me-1" alt="Charles Hall" /> <span className="text-dark">Thales</span>
						</a>
						<div className="dropdown-menu dropdown-menu-end">
							<Link className="dropdown-item" to="/meus-dados"><i className="align-middle me-1 bi bi-person"></i> Meus Dados</Link>
							<Link className="dropdown-item" to="/trocar-senha"><i className="align-middle me-1 bi bi-key"></i> Trocar Senha</Link>
							<div className="dropdown-divider"></div>
							<Link className="dropdown-item" to="/logout"><i className="me-1 bi bi-box-arrow-left"></i> Sair</Link>
						</div>
					</li>
				</ul>
			</div>
		</nav>

		<main role="main" className="content">
			<div className="container-fluid p-0">
				{children}
			</div>
		</main>

		<footer className="footer">
			<div className="container-fluid">
				<div className="row text-muted">
					<div className="col-6 text-start">
						<p className="mb-0">
							<a className="text-muted" href="#" target="_blank"><strong>Imob</strong></a> &copy;
						</p>
					</div>						
				</div>
			</div>
		</footer>
	</div>
</div>
  );
};

export default Layout;